import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { X } from 'lucide-react';
import { api } from '../lib/api';

/** Hash simples e estável do conteúdo — campanha nova (texto/URL diferente) reaparece. */
function hashText(s: string): string {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) | 0;
  return String(h >>> 0);
}

function readDismissed(key: string): boolean {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

/**
 * Barra promocional no topo da plataforma (controlada pelo admin via banner.top).
 * Azul, full-width, dismissível com X — o fechamento persiste no localStorage por
 * hash do conteúdo, então uma nova campanha volta a aparecer.
 */
export function TopPromoBar() {
  const meQuery = useQuery({ queryKey: ['trader-me'], queryFn: () => api.getTraderMe() });
  const banner = meQuery.data?.banners?.top;
  const [closed, setClosed] = useState(false);

  if (!banner?.enabled || !banner.text) return null;

  const key = `pnl_topbar_dismissed_${hashText(banner.text + (banner.buttonUrl ?? ''))}`;
  if (closed || readDismissed(key)) return null;

  function close() {
    try {
      localStorage.setItem(key, '1');
    } catch {
      /* ignora storage indisponível */
    }
    setClosed(true);
  }

  return (
    <div className="relative bg-gradient-to-r from-[#0D1580] to-[#1E6FFF] text-white">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-center gap-x-4 gap-y-1 px-10 py-2.5 text-sm sm:px-12">
        <p className="text-center font-medium">{banner.text}</p>
        {banner.buttonUrl && (
          <a
            href={banner.buttonUrl}
            target="_blank"
            rel="noreferrer"
            className="shrink-0 rounded-md bg-white/15 px-3 py-1 text-xs font-semibold transition-colors hover:bg-white/25"
          >
            {banner.buttonText || 'Pegar o Desconto'}
          </a>
        )}
      </div>
      <button
        type="button"
        onClick={close}
        aria-label="Fechar"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-md p-1 text-white/80 transition-colors hover:bg-white/15 hover:text-white"
      >
        <X size={16} />
      </button>
    </div>
  );
}
